export enum InputType {
    NUMBER = 'NUMBER',
    TEXT = 'TEXT',
    SELECT = 'SELECT',
    TABLE = 'TABLE',
    ADDRESS = 'ADDRESS'
}
